// PostHog feature flag keys. Values must match the flag keys in PostHog.
export const POSTHOG_FLAGS = {
  SHOW_OPPORTUNITY_STATUS_DROPDOWN: 'show-opportunity-status-dropdown',
  TELEHEALTH_DIAGNOSTICS: 'telehealth-diagnostics',
  VYTAL_INSIGHTS: 'vytal-insights',
  TELEHEALTH_THREE_WAY_CALLING: 'telehealth-three-way-calling',
  DESKTOP_CALL_NOTIFICATIONS: 'desktop-call-notifications',
};
